<template>
    <div class="uploadAttachment">
        <div class="title">
            <span>上传附件</span>
            <span class="content">选择您要上传的照片</span>
        </div>
        <div class="uploadBox">
            <van-uploader
                :after-read="afterRead"
                multiple
                accept="image/*"
                preview-image
                v-model="files"
                preview-full-image
                preview-size="72px"
                :before-delete="handleDelete"
            />
        </div>
    </div>
</template>
<script>
    import api from '@/service/modules/complaint';
    import util from '@/utils/common';
    export default {
        props: { imgUrl: Array },
        data () {
            return {
                files: [], // 待上传的文件
                uploadFile: [] // 上传成功后的文件
            };
        },

        watch: {
            imgUrl: {
                handler (newValue, oldValue) {
                    console.log(newValue);
                    this.files = [];
                    this.uploadFile = [];
                    // if(Array.isArray(newValue) && newValue.length ==1){
                    //     console.log(newValue[0]);
                    // }
                    if (Array.isArray(newValue) && newValue.length > 0) {
                        for (let i = 0; i < newValue.length; i++) {
                            this.files.push({ url: newValue[i].url.split('?')[0] });
                            this.uploadFile.push(newValue[i]);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            // 删除预览文件
            handleDelete (files) {
                if (files instanceof Object) {
                    if (files.hasOwnProperty('file')) {
                        // 删除源文件
                        this.files = this.files.filter(item => {
                            return item['file'] == undefined;
                        });
                    } else if (files.hasOwnProperty('url')) {
                        // 删除上传成功后预览文件
                        this.files = this.files.filter(item => {
                            return item.url != files['url'];
                        });
                        this.uploadFile = this.uploadFile.filter(item => {
                            return item.url.split('?')[0] != files['url'];
                        });
                    }
                    let imgFiles = [...this.uploadFile];
                    this.$dispatch('fileUploadData', imgFiles);
                    return true;
                }
            },
            afterRead (files) {
                let fileSource = this.$attrs.fileSource
                    ? this.$attrs.fileSource
                    : 2;
                let fileBizType = this.$attrs.fileBizType
                    ? this.$attrs.fileBizType
                    : 1;
                // 此时可以自行将文件上传至服务
                if (Array.isArray(files)) {
                    files.forEach(item => {
                        let formData = new FormData();
                        formData.append('files', item.file);
                        formData.append('fileSource', fileSource);
                        formData.append('fileBizType', fileBizType);
                        this.handleUploadFile(formData, item);
                    });
                } else {
                    let formData = new FormData();
                    formData.append('files', files.file);
                    formData.append('fileSource', fileSource);
                    formData.append('fileBizType', fileBizType);
                    this.handleUploadFile(formData, files);
                }
            },
            handleUploadFile (data, files) {
                this.$Toast.loading({
                    duration: 0,
                    message: '文件上传中...',
                    forbidClick: true
                });
                let config = {
                    headers: {
                        // 添加请求头
                        'Content-Type': 'multipart/form-data',
                        // 'X-Token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNTg3NDM2OTg0IiwiaWF0IjoiMTU4NjgzMjE4NCIsInV1aWQiOiIyMDY5NzFmZS1mZTAwLTRjYTEtOTdlOS1iMjcxMTZlNTg2N2EifQ.e1jMxChbox6p-VWcrVGP-yY0xWQfgzJLg0dRGOFUppw'
                    }
                };
                try {
                    this.axios
                        .post(
                            'tio/integrity/img/upload/api/attach/fileUpload',
                            data,
                            config
                        )
                        .then(res => {
                            if (res.data.ret === 0 && res.data.data) {
                                this.uploadFile.push(res.data.data[0]);
                                this.handleDelete(files);
                            }
                            this.$Toast.clear();
                        });
                } catch (error) {
                    this.$Toast.clear();
                }
            }
        }
    };
</script>

<style lang="less" scoped>
.uploadAttachment {
    width: 100%;
    .title {
        font-size: 14px;
        .content {
            font-size: 12px;
            color: #aaa;
        }
        height: 60px;
    }
    .uploadBox {
        margin-bottom: -20px;
    }
}
</style>
